<script>
export default {
    name: "SizeSelect",
    props: [ "data", "value" ],
    data() {
        return {
            activeIndex: null,
            isShowOptions: false,
        };
    },
    computed: {},
    components: {
        
    },
    mounted() {
        window.addEventListener('click', this.hideOption);
    },
    destroyed() {
        window.removeEventListener('click', this.hideOption);
    },
    watch: {
        value: {
            handler: function(val){
                for (let i = 0; i < this.data.length; i++) {
                    const item = this.data[i];
                    if(item.id == val){
                        this.activeIndex = i;
                        break;
                    }
                }
            },
            immediate: true
        }
    },
    methods: {
        hideOption(){
            this.isShowOptions = false;
        },
        showOption(){
            this.isShowOptions = true;
        },
        changeSize(index, id){
            this.activeIndex = index;
            this.$emit("input", id);
        },
    },
};
</script>

<template>
    <div class="select" :class="{active: isShowOptions}">
        <div class="value" @click.stop="isShowOptions = !isShowOptions">
            <span v-if="activeIndex == null">Select Size</span>
            <span v-else>{{data[activeIndex].name}}</span>
        </div>
        <div class="option_group" v-if="isShowOptions">
            <div class="item" v-for="(item, index) in data" :key="index" @click="changeSize(index, item.id)">{{item.name}}</div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.select{
    width: 100%;
    height: 40px;
    user-select: none;
    font-size: 12px;
    position: relative;
    font-weight: normal;
    z-index: 9;
    .value{
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 10px;
        cursor: pointer;
        border: 1px solid #000;
        &::after{
            content: "";
            display: block;
            width: 6px;
            height: 6px;
            border-right: 1px solid #000;
            border-bottom: 1px solid #000;
            transform: translate(-50%, -50%) rotate(45deg);
        }
    }
    .option_group{
        background: #fff;
        position: absolute;
        top: calc(100% - 1px);
        left: 0;
        width: 100%;
        border: 1px solid #000;
        .item{
            padding: 0 10px;
            height: 40px;
            line-height: 40px;
            cursor: pointer;
            &:hover{
                background: #f3f3f3;
            }
        }
    }
    @media screen and (max-width: 768px) {
        font-size: .24rem;
        height: .7rem;
        .value{
            padding: 0 .2rem;
            &::after{
                width: .1rem;
                height: .1rem;
            }
        }
        .option_group{
            .item{
                padding: 0 .2rem;
                height: .7rem;
                line-height: .7rem;
            }
        }
    }
}
</style>